@if (showCourseInstancePage$()) {
  @let checkBoxState = clearingCheckboxState$();
  @let noClearingAvailable = clearingPage && !totalCourseInstanceCount$() && !filtersApplied();
  @let unSavedChanges = clearingAvailableUpdatePending$() || editingSecretUcas$();
  @let unSavedUcaseChanges = unSavedChanges && editingSecretUcas$();
  @let unSavedCheckboxChanges = unSavedChanges && clearingAvailableUpdatePending$();

  <div class="create_campus_sec" id="manage_course">
    <div class="campus_rightpanel">
      <div class="manage_course instance_listing_page" [ngClass]="{'no-clearing-course-wrapper': noClearingAvailable}">
        <div [ngClass]="fromCourseListingPage? 'institution_details' :'edit_popup'">
          @if (!fromCourseListingPage) {
            <div class="edit_title">{{courseDetails?.pageType === 'assignedErInstances' ? 'Course instance' : 'Instances'}}<a class="material-icons"
            mat-dialog-close>close</a></div>
          }

          @if (!clearingPage && (fromCourseListingPage || courseDetails?.pageType === 'assignedErInstances')) {
            <a class="back_btn" [ngClass]="{'er_assigned_instance_back_btn': courseDetails?.pageType === 'assignedErInstances'}" (click)="redirectToCourseListing()">
              <span class="material-icons">chevron_left</span>BACK</a>
            }

            <div class="course_detail m-b-20">
              @if (courseDetails?.courseName) {
                <div class="first_campus_status"><p>Course: </p><span>{{courseDetails?.courseName}}</span></div>
              }
            </div>
            @if (fromCourseListingPage) {
              <app-page-header pageName="{{pageTitle()}}"></app-page-header>
            }
            <app-notes-success-popup />

            @if (successOrWarnPopupType()) {
              <app-success-or-warning-popup [popupType]="successOrWarnPopupType()" [displayText]="successOrWarnMsg()" />
            }

            @if (util.saveCourseInstanceSuccessPopup$()) {
              <div class="success_created">
                <span class="material-icons done-color">done</span>
                <p>{{util.saveCourseInstanceSuccessPopup$()}}</p>
                <a class="material-icons" (click)="util.saveCourseInstanceSuccessPopup$.set('')">close</a>
              </div>
            }

            @if (ucasFieldInvalidSubmit$()) {
              <div class="m-b-20 warning_alert">
                <span class="material-icons warning-color">error_outline</span>
                <p>Please enter a valid Secret UCAS Tariff value in the range of 0 to 360.</p>
                <a class="material-icons" (click)="null">close</a>
              </div>
            }

            @if (clearingAvailableUpdatePending$()) {
              <div id="toastBox">
                <div class="toast_alert_popup">
                  <div class="toast_content">After making all the necessary clearing availability updates on this page, click Save</div>
                  <div class="toast_btn_group">
                    <button class="toast_yes" mat-stroked-button (click)="onClearingAvailableSave()" >SAVE</button>
                    <button class="toast_no" (click)="onClearingAvailableReset()" >CLEAR</button>
                  </div>
                </div>
              </div>
            }

            @if(!noClearingAvailable && fromCourseListingPage){
              <div class="top_flex">
                <div class="custom_btn"><img src="/assets/images/icon-left.svg" width="" height="" alt="CUSTOMISE TABLE">
                  <p>CUSTOMISE TABLE</p>
                </div>
                <div class="more_btn">
                  @if(clearingPage) {
                    <div [matMenuTriggerFor]="menu" roleAccessControl accessType="clearingReportDownload" #access="accessControl">
                      <p>More </p><span class="material-icons more_color_ch">more_horiz</span>
                      <mat-menu class="clearing_menu_table more_menu" #menu="matMenu">
                        @if (!['initiate', 'completed'].includes(courseInstanceListData()?.initiateStatus?.toLowerCase())) {
                          <button mat-menu-item (click)="downloadClearingReport('init')"><span>Initiate Clearing Report Download</span></button>
                        }
                        @if (courseInstanceListData()?.initiateStatus?.toLowerCase() === 'initiate') {
                          <button mat-menu-item class="disable_menu_button" disabled="true"><span class="disable_report">Report Generation in Progress</span></button>
                        }
                        @if (courseInstanceListData()?.initiateStatus?.toLowerCase() === 'completed') {
                          <button mat-menu-item (click)="downloadClearingReport('download')"><span>Download Clearing Report</span></button>
                        }
                        <button mat-menu-item (click)="openClearingUploadPopup()" [ngClass]="{'disable_menu_button': ['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())}" [disabled]="['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())" roleAccessControl accessType="clearingReportUpload" #access="accessControl">
                          <span [ngClass]="{'disable_report': ['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())}">Upload Clearing Report</span>
                        </button>
                        <button mat-menu-item (click)="courseCommonFn.openModuleReportList(institutionDetails,'clearing', 'Clearing')" [ngClass]="{'disable_menu_button': !courseInstanceListData()?.clearingReportCount}" [disabled]="!courseInstanceListData()?.clearingReportCount" roleAccessControl accessType="clearingViewReport" #access="accessControl">
                          <span [ngClass]="{'disable_report': !courseInstanceListData()?.clearingReportCount}">View Clearing Report</span>
                        </button>
                      </mat-menu>
                    </div>
                  }
                  @else {
                  <div><p class="more_opt_lbl">More </p><span class="material-icons more_color_ch">more_horiz</span></div>
                  @if (countryId == constVars.ukCountryId) {
                    <div class="stages_module_upd_dwnld" [matMenuTriggerFor]="uploadDownloadMenu" roleAccessControl accessType="stagesModulesDownload" #access="accessControl">
                      <p>Manage stages & modules </p>
                      <mat-menu class="upload_download_menu_table more_menu" #uploadDownloadMenu="matMenu">
                        @if (!['initiate', 'completed'].includes(courseInstanceListData()?.initiateStatus?.toLowerCase())) {
                          <button mat-menu-item (click)="downloadStagesModulesReport('init')" roleAccessControl accessType="stagesModulesDownload" #access="accessControl"><span>Initiate Module Report Download</span></button>
                        }
                        @if (courseInstanceListData()?.initiateStatus?.toLowerCase() === 'initiate') {
                          <button mat-menu-item class="disable_menu_button" disabled="true" roleAccessControl accessType="stagesModulesDownload" #access="accessControl"><span class="disable_report">Report Generation in Progress</span></button>
                        }
                        @if (courseInstanceListData()?.initiateStatus?.toLowerCase() === 'completed') {
                          <button mat-menu-item (click)="downloadStagesModulesReport('download')" roleAccessControl accessType="stagesModulesDownload" #access="accessControl"><span>Download Module Report</span></button>
                        }
                        <button mat-menu-item (click)="openUploadPopup()" [ngClass]="{'disable_menu_button': ['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())}" [disabled]="['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())" roleAccessControl accessType="stagesModulesUpload" #access="accessControl"><span [ngClass]="{'disable_report': ['uploading', 'in progress'].includes(courseInstanceListData()?.uploadStatus?.toLowerCase())}">Upload Stages and module</span></button>
                        <button mat-menu-item (click)="courseCommonFn.openModuleReportList(institutionDetails, 'stagesModules', 'Module')" [ngClass]="{'disable_menu_button': !courseInstanceListData()?.moduleReportCount}" [disabled]="!courseInstanceListData()?.moduleReportCount" roleAccessControl accessType="stagesModulesViewReport" #access="accessControl"><span [ngClass]="{'disable_report': !courseInstanceListData()?.moduleReportCount}">View module report</span></button>
                      </mat-menu>
                    </div>
                  }
                }
                @if ((searchInstanceFields | json) !== '{}') {
                  <div class="clear_btn" (click)="clearInstanceFilter()">
                    <svg width="22" height="22" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path id="myPath"
                        d="M1 2C1 1.44772 1.44772 1 2 1H10C10.5523 1 11 1.44772 11 2V2.80801C11 3.07323 10.8946 3.32758 10.7071 3.51512L7.404 6.81822C7.21647 7.00575 7.11111 7.26011 7.11111 7.52532V8.77778L4.88889 11V7.52533C4.88889 7.26011 4.78353 7.00575 4.596 6.81822L1.29289 3.51512C1.10536 3.32758 1 3.07323 1 2.80801V2Z"
                        stroke="#555555" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round" />
                        <circle id="myPath1" cx="10.5" cy="5.5" r="2.935" fill="#555555" stroke="#555555" stroke-width="1.13" />
                        <path id="myPath2" d="M8.37891 5.5L12.6215 5.5" stroke="#ffffff" stroke-width="1.13" />
                      </svg>
                      <span>Clear Filter</span>
                    </div>
                  }
                  @if (!clearingPage) {
                    <button (click)="createNewInstance()" class="create_institution gap_btn" [ngClass]="{'instance_create_disable':courseStatus()?.toLowerCase() !== 'live'}" mat-stroked-button roleAccessControl accessType="create"><span class="material-icons">add</span>CREATE NEW</button>
                  }
                </div>
              </div>
            }

            @if (!fromCourseListingPage) {
              <div class="btn_count">
                @if ((searchInstanceFields | json) !== '{}') {
                  <div class="clear_btn" (click)="clearInstanceFilter()">
                    <svg width="22" height="22" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path id="myPath"
                        d="M1 2C1 1.44772 1.44772 1 2 1H10C10.5523 1 11 1.44772 11 2V2.80801C11 3.07323 10.8946 3.32758 10.7071 3.51512L7.404 6.81822C7.21647 7.00575 7.11111 7.26011 7.11111 7.52532V8.77778L4.88889 11V7.52533C4.88889 7.26011 4.78353 7.00575 4.596 6.81822L1.29289 3.51512C1.10536 3.32758 1 3.07323 1 2.80801V2Z"
                        stroke="#555555" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round" />
                        <circle id="myPath1" cx="10.5" cy="5.5" r="2.935" fill="#555555" stroke="#555555" stroke-width="1.13" />
                        <path id="myPath2" d="M8.37891 5.5L12.6215 5.5" stroke="#ffffff" stroke-width="1.13" />
                      </svg>
                      <span>Clear Filter</span>
                    </div>
                  }
                  @if(pageUrl.includes('edit-course') && courseDetails?.pageType !== 'assignedErInstances'){
                    <button (click)="createNewInstance()" class="create_institution gap_btn" [ngClass]="{'instance_create_disable':courseStatus()?.toLowerCase() !== 'live'}" mat-stroked-button roleAccessControl accessType="create"><span class="material-icons">add</span>CREATE NEW</button>
                  }
                </div>
              }

              @if(noClearingAvailable){
                <div class="no-clearing-course">
                  <!--<p class="no-clearing-course-title">Clearing course management</p>-->
                  <div class="no-course-box">
                    <div class="no-course-contents">
                      <p class="no-course-title">No clearing courses available</p>
                      <p class="no-course-para">It seems there are no clearing courses available</p>
                    </div>
                    <img [src]="imageUrlsConst.noClearingInstance" alt="no clearing course" width="502" height="354" class="no-course-img"/>
                  </div>
                </div>
              }
              @else {
              <div [ngClass]="fromCourseListingPage? 'course_table': 'edit_instance_details'">

                <!-- table -->
                <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onTableSortedOrderChange($event)"
                  class="mat-elevation-z8">

                  <ng-container matColumnDef="available">
                    <th mat-header-cell *matHeaderCellDef>
                      @if(!disableSelectAll$()){
                        <mat-checkbox roleAccessControl accessType="updateClearingAvailable" [checked]="selectAll$()" [disabled]="unSavedUcaseChanges" (change)="onCheckBoxChange('selectAll', $event, 0)" disableRipple></mat-checkbox>
                      }
                      <span class="heading_name">Available</span>
                      @if (!unSavedChanges) {
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.Available]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.Available,'Clearing Applicable', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.Available]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.Available)">
                                <div class="tooltip">
                                  <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.Available) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      }
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox roleAccessControl #roleAccess="accessControl" accessType="updateClearingAvailable" class="check_name" [checked]="checkBoxState.get(element.courseInstanceChannelId)?.checked" [disabled]="(unSavedUcaseChanges || element.status?.toLowerCase() === 'archived')" (change)="onCheckBoxChange('box', $event, element.courseInstanceChannelId)" disableRipple></mat-checkbox>
                      @if(!roleAccess?.accessControl) {
                        <mat-checkbox class="check_name" [checked]="checkBoxState.get(element.courseInstanceChannelId)?.checked" disabled="true" disableRipple></mat-checkbox>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="courseInstanceTitle">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="heading_name">{{ clearingPage ? 'Instance' : 'title'}}</span>
                      @if (!unSavedChanges) {
                        <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.CourseInstanceTitleFieldId]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.CourseInstanceTitleFieldId,'Course instance title', 'AJAX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.CourseInstanceTitleFieldId]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.CourseInstanceTitleFieldId)">
                                <div class="tooltip">
                                  <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.CourseInstanceTitleFieldId) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      }
                    </th>
                    @if (courseDetails?.pageType !== 'assignedErInstances') {
                      <td class="instances_table_cell generl-english" mat-cell *matCellDef="let element">
                        <div [ngClass]="{'instances_name' : !unSavedChanges}">
                          @if (element.newNotes) {
                            <a class="notes_icon material-icons">insert_drive_file
                              <div class="notes_tooltip">New note added</div>
                            </a>
                          }
                          <a [ngClass]="{'disable_ptr': unSavedChanges}" (click)="redirectToInstanceDetails(element, roleAccess?.accessControl)" roleAccessControl #roleAccess="accessControl" [accessPage]="['edit-course', 'view-course']"> {{element.courseInstanceTitle}}</a>
                          @if (element.ucasSupplied) {
                            <div class="archived course_status">UCAS</div>
                          }
                          @if (element.forwardGeneratedInstance === 'Y') {
                            <div class="archived course_status">FG</div>
                          }
                        </div>
                      </td>
                    } @else {
                      <td mat-cell class="generl-english" *matCellDef="let element"> {{element.courseInstanceTitle}} </td>
                    }
                  </ng-container>

                  <ng-container matColumnDef="courseTitle">
                    <th mat-header-cell *matHeaderCellDef class="course_code_max_width">
                      <span class="heading_name">Course</span>
                      @if (!unSavedChanges) {
                        <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by course title"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.CourseTitle]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.CourseTitle,'Course Name', 'AJAX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.CourseTitle]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.CourseTitle)">
                                <div class="tooltip">
                                  <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.CourseTitle) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      }
                    </th>
                    <td mat-cell class="course_code_max_width" *matCellDef="let element" [title]="element?.courseTitle" > {{element?.courseTitle}} </td>
                  </ng-container>

                  <ng-container matColumnDef="qualificationType">
                    <th mat-header-cell *matHeaderCellDef class="course_code_max_width">
                      <span class="heading_name">Qualification Type</span>
                      @if (!unSavedChanges) {
                        <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by qualification type"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.QualificationTypeId]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.QualificationTypeId,'Qualification', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.QualificationTypeId]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.QualificationTypeId)">
                                <div class="tooltip">
                                  <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.QualificationTypeId) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      }
                    </th>
                    <td mat-cell *matCellDef="let element" class="course_code_max_width" title="{{element?.qualificationType || '-'}}"> {{element?.qualificationType || '-'}} </td>
                  </ng-container>

                  <ng-container matColumnDef="ucasCode">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="heading_name">UCAS code</span>
                      @if (!unSavedChanges) {
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.UCASCode]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.UCASCode,'UCAS code', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.UCASCode]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.UCASCode)">
                                <div class="tooltip">
                                  <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.UCASCode) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      }
                    </th>
                    <td mat-cell *matCellDef="let element"> {{(element?.ucasCode === null) ? '-' : element?.ucasCode}} </td>
                  </ng-container>

                  <ng-container matColumnDef="secretUcasTariff">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="heading_name">Secret UCAS Tariff</span>
                    </th>
                    <td mat-cell *matCellDef="let element" [ngClass]="{'no-padding' : editingSecretUcas$() === element.courseInstanceId}" >

                      <!-- secret ucas tariff hover flow  -->
                      @if (editingSecretUcas$() != element.courseInstanceId) {
                        <div class="tariffCode">
                          <p>{{(element?.secretUcasTariff === null) ? '-' : element?.secretUcasTariff}}</p>
                          <!-- edit icon -->
                          @if (!editingSecretUcas$() && !unSavedCheckboxChanges && element.status?.toLowerCase() !== 'archived') {
                            <span class="edit_icon" roleAccessControl accessType="updateSecretUcasTariff" (click)="onUcasEdit(element)">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M12.5089 4.73277L15.2533 7.47722M13.6732 3.56839C14.4311 2.81054 15.6598 2.81054 16.4177 3.56839C17.1756 4.32625 17.1756 5.55499 16.4177 6.31284L5.73054 17H3.01367V14.228L13.6732 3.56839Z"
                                  stroke="#555555" class="svg-path" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </span>
                            }
                          </div>
                        }

                        <!-- editing secret ucas tariff flow  -->
                        @if (editingSecretUcas$() === element.courseInstanceId) {
                          <div class="editIDField editable_container">
                            <input class="editIDInputField" maxlength="3" [(ngModel)]="ucasFieldValue.value" [ngClass]="{'tariffIDWarning': !isSecretUcasValid(), 'tariffIDCursor': isSecretUcasValid()}"/>
                            <!-- save & cancel button -->
                            <div class="edit_overlay">
                              <!-- save -->
                              <span class="save_icon" (click)="onUcasFieldSave()" >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 8.71443L5.85714 11.5716L13 4.42871" stroke="#555555" stroke-width="1.13"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>

                                  <!-- cancel -->
                                </span>
                                <span class="cancel_icon" (click)="onUcasEditCancel()">
                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 12L12 4M4 4L12 12" stroke="#555555" stroke-width="1.13" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                    </svg>

                                  </span>
                                </div>

                              </div>
                            }

                          </td>
                        </ng-container>

                        <ng-container matColumnDef="courseInstanceId">
                          <th mat-header-cell *matHeaderCellDef>
                            <span class="heading_name">course instance id</span>
                            <span class="filter_hover">
                              <div class="filter_column">
                                @if (!searchInstanceFields[courseInstanceFilterDetails.InstanceIdFieldId]) {
                                  <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.InstanceIdFieldId,'Course instance ID', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                                }
                                @if (searchInstanceFields[courseInstanceFilterDetails.InstanceIdFieldId]) {
                                  <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.InstanceIdFieldId)">
                                    <div class="tooltip">
                                      <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                      <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                    </div>
                                  </button>
                                }
                              </div>
                              @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.InstanceIdFieldId) {
                                <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                              }
                            </span>
                          </th>
                          <td mat-cell *matCellDef="let element"> {{element.courseInstanceId}} </td>
                        </ng-container>

                        <ng-container matColumnDef="idpCNCourseId">
                          <th mat-header-cell *matHeaderCellDef>
                            <span class="heading_name">IDP CN course ID</span>
                            <span class="filter_hover">
                              <div class="filter_column">
                                @if (!searchInstanceFields[courseInstanceFilterDetails.idpCNCourseId]) {
                                  <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.idpCNCourseId,'IDP CN course ID', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                                }
                                @if (searchInstanceFields[courseInstanceFilterDetails.idpCNCourseId]) {
                                  <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.idpCNCourseId)">
                                    <div class="tooltip">
                                      <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                      <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                    </div>
                                  </button>
                                }
                              </div>
                              @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.idpCNCourseId) {
                                <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                              }
                            </span>
                          </th>
                          <td mat-cell *matCellDef="let element"> {{element?.idpCNCourseId}} </td>
                        </ng-container>

                        <ng-container matColumnDef="idpcLegacyCourseId">
                          <th mat-header-cell *matHeaderCellDef>
                            <span class="heading_name">IDPC legacy course ID</span>
                            <span class="filter_hover">
                              <div class="filter_column">
                                @if (!searchInstanceFields[courseInstanceFilterDetails.idpcLegacyCourseId]) {
                                  <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.idpcLegacyCourseId,'IDPC legacy course ID', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                                }
                                @if (searchInstanceFields[courseInstanceFilterDetails.idpcLegacyCourseId]) {
                                  <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.idpcLegacyCourseId)">
                                    <div class="tooltip">
                                      <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                      <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                    </div>
                                  </button>
                                }
                              </div>
                              @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.idpcLegacyCourseId) {
                                <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                              }
                            </span>
                          </th>
                          <td mat-cell *matCellDef="let element"> {{element?.idpcLegacyCourseId}} </td>
                        </ng-container>

                        <ng-container matColumnDef="courseTypeId">
                          <th mat-header-cell *matHeaderCellDef>
                            <span class="heading_name">Course Instance Type</span> <span class="sorting_icon" mat-sort-header
                          sortActionDescription="Sort by name"></span>
                          <span class="filter_hover">
                            <div class="filter_column">
                              @if (!searchInstanceFields[courseInstanceFilterDetails.CourseTypeIdFieldId]) {
                                <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.CourseTypeIdFieldId,'English course type', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                              }
                              @if (searchInstanceFields[courseInstanceFilterDetails.CourseTypeIdFieldId]) {
                                <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.CourseTypeIdFieldId)">
                                  <div class="tooltip">
                                    <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                    <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                  </div>
                                </button>
                              }
                            </div>
                            @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.CourseTypeIdFieldId) {
                              <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                            }
                          </span>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.courseInstanceType}}</td>
                      </ng-container>

                      <ng-container matColumnDef="applicableForFastlane">
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="heading_name">Applicable to Fastlane</span>
                          <span class="filter_hover">
                            <div class="filter_column">
                              @if (!searchInstanceFields[courseInstanceFilterDetails.ApplicableToFastlane]) {
                                <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.ApplicableToFastlane,'Applicable To Fastlane', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                              }
                              @if (searchInstanceFields.hasOwnProperty(courseInstanceFilterDetails.ApplicableToFastlane)) {
                                <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.ApplicableToFastlane)">
                                  <div class="tooltip">
                                    <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                    <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                  </div>
                                </button>
                              }
                            </div>
                            @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.ApplicableToFastlane) {
                              <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                            }
                          </span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="fastlane_applicable_col"> {{util.dataTypeOf(element.applicableForFastlane) === 'boolean' ? (element.applicableForFastlane ? 'Yes' : 'No') : 'No data'}} </td>
                      </ng-container>

                      <ng-container matColumnDef="courseCodeType">
                        <th mat-header-cell *matHeaderCellDef class="course_code_max_width">
                          <span class="heading_name"> code type</span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="course_code_max_width" title="{{element?.courseInstanceCodeValues?.courseCodeType || ''}}"> {{element?.courseInstanceCodeValues?.courseCodeType || ''}} </td>
                      </ng-container>

                      <ng-container matColumnDef="courseCode">
                        <th mat-header-cell *matHeaderCellDef class="course_code_max_width">
                          <span class="heading_name"> code</span>
                          <span class="filter_hover">
                            <div class="filter_column">
                              @if (!searchInstanceFields[courseInstanceFilterDetails.CourseCodeFieldId]) {
                                <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.CourseCodeFieldId, 'Code', 'EXACT_MATCH')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                              }
                              @if (searchInstanceFields[courseInstanceFilterDetails.CourseCodeFieldId]) {
                                <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.CourseCodeFieldId)">
                                  <div class="tooltip">
                                    <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                    <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                  </div>
                                </button>
                              }
                            </div>
                            @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.CourseCodeFieldId) {
                              <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                            }
                          </span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="course_code_max_width" title="{{element?.courseInstanceCodeValues?.courseCode || ''}}"> {{element?.courseInstanceCodeValues?.courseCode || ''}} </td>
                      </ng-container>

                      <ng-container matColumnDef="academicYear">
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="heading_name">Academic year</span>
                          @if (!unSavedChanges) {
                            <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by academic year"></span>
                            <span class="filter_hover">
                              <div class="filter_column">
                                @if (!searchInstanceFields[courseInstanceFilterDetails.AcademicYearFieldId]) {
                                  <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.AcademicYearFieldId,'Academic year', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                                }
                                @if (searchInstanceFields[courseInstanceFilterDetails.AcademicYearFieldId]) {
                                  <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.AcademicYearFieldId)">
                                    <div class="tooltip">
                                      <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                      <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                    </div>
                                  </button>
                                }
                              </div>
                              @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.AcademicYearFieldId) {
                                <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                              }
                            </span>
                          }
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.academicYear}} </td>
                      </ng-container>

                      <ng-container matColumnDef="typicalDuration">
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="heading_name">Typical duration</span> <span class="sorting_icon" mat-sort-header
                        sortActionDescription="Sort by name"></span>
                        <span class="filter_hover">
                          <div class="filter_column">
                            @if (!searchInstanceFields[courseInstanceFilterDetails.TypicalDurationFieldId]) {
                              <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.TypicalDurationFieldId,'Typical duration', 'AJAX')" src="filter_icon.png"><img [src]="imageUrlsConst.filterIcon" alt="Filter Icon"></button>
                            }
                            @if (searchInstanceFields[courseInstanceFilterDetails.TypicalDurationFieldId]) {
                              <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.TypicalDurationFieldId)">
                                <div class="tooltip">
                                  <img [src]="imageUrlsConst.clearFilterIcon" alt="Filter Icon" width="20">
                                  <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                </div>
                              </button>
                            }
                          </div>
                          @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.TypicalDurationFieldId) {
                            <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                          }
                        </span>
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.typicalDuration}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="heading_name">Status</span>
                        @if (!unSavedChanges) {
                          <span class="sorting_icon" mat-sort-header sortActionDescription="Sort by name"></span>
                          <span class="filter_hover">
                            <div class="filter_column">
                              @if (!searchInstanceFields[courseInstanceFilterDetails.StatusFieldId]) {
                                <button class="fliter_icon" (click)="showInstanceFilterOption(courseInstanceFilterDetails.StatusFieldId,'Status', 'SELECT_BOX')" src="filter_icon.png"><img src="/assets/images/top-icon/filter-icon.svg" alt="Filter Icon"></button>
                              }
                              @if (searchInstanceFields[courseInstanceFilterDetails.StatusFieldId]) {
                                <button class="fliter_icon_clear" (click)="clearInstanceFilter(courseInstanceFilterDetails.StatusFieldId)">
                                  <div class="tooltip">
                                    <img src="/assets/images/top-icon/clearfilter.svg" alt="Filter Icon" width="20">
                                    <span class="tooltiptext Clear-tooltip">Clear filter</span>
                                  </div>
                                </button>
                              }
                            </div>
                            @if (hideShowFilterOption$() && instanceData$().filterId === courseInstanceFilterDetails.StatusFieldId) {
                              <app-manage-filter [filterDetails]="instanceData$()" (closeFilterPopup)="closeInstanceFilterPopup()" (searchIntakeFilter)="searchAppliedInstanceFilter($event)"></app-manage-filter>
                            }
                          </span>
                        }
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div class="course_status {{element.status | lowercase}}">{{element.status}}</div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="detailEr">
                      <th mat-header-cell *matHeaderCellDef [ngClass]="{'hide_table_column': !fromCourseListingPage}">
                        <span class="heading_name">Detailed ER</span>
                      </th>
                      <td mat-cell *matCellDef="let element" class="er_icon_wrapper er_count_td"
                        [ngClass]="{'hide_table_column': !fromCourseListingPage }">
                        <div id="erIconAutomationId" class="ER-cusor"
                          [ngClass]="{'icon_disable' : (element.status?.toLowerCase() === 'archived' || unSavedChanges || courseTypeId == courseTypeDetails.EFLCourseTypeId) }"
                          (click)="restrictStudentType(element);redirectToDetailedER(element)"><img [src]="(element.erAssignedCount === 0) ? imageUrlsConst.detailErIcon : imageUrlsConst.detailEravailIcon"
                          alt="Filter Icon">
                          <div class="er_tooltip">
                            <span class="er_avail_updt">This course instance has {{element.erAssignedCount}} assigned Entry
                            Requirement(s)</span>
                          </div>
                        </div>
                        @if (element?.erQualNew) {
                          <div class="er_updated">updated</div>
                        }
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="availability">
                      <th mat-header-cell *matHeaderCellDef [ngClass]="{'hide_table_column': courseDetails?.pageType === 'assignedErInstances'}">
                        <span class="heading_name">Availability</span>
                      </th>
                      <td mat-cell *matCellDef="let element" class="er_count_td" [ngClass]="{'hide_table_column': courseDetails?.pageType === 'assignedErInstances'}">
                        <div class="ER-cusor" [ngClass]="{'icon_disable': (element.status?.toLowerCase() === 'archived' || unSavedChanges)}" (click)="goToAvailabilityPage(element)">
                          <img id="avlIconAutomationId" roleAccessControl #roleAccess="accessControl" class="avail-icon-clr"
                            [src]="element.availabilityActiveCount > 0 ? imageUrlsConst.availabiliyAvailIcon : imageUrlsConst.calenderIcon"
                            alt="availability-icon">
                            <div class="er_tooltip">
                              <span class="er_avail_updt">{{getAvailabilityTooltip(element)}}</span>
                            </div>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="courseInstanceURL">
                        <th mat-header-cell *matHeaderCellDef [ngClass]="{'hide_table_column': courseDetails?.pageType === 'assignedErInstances'}">
                          <span class="heading_name">url</span>
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'hide_table_column': courseDetails?.pageType === 'assignedErInstances'}">
                          <a href="{{ element.courseInstanceURL }}" target="_blank">
                            <span class="material-icons-outlined url_color">
                              open_in_new
                            </span>
                          </a>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="menu">
                        <th [ngClass]="{'hide_table_column': !fromCourseListingPage}" mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                        <td [ngClass]="{'hide_table_column': !fromCourseListingPage, 'disable_ptr': unSavedChanges}" class="menu_bar" [matMenuTriggerFor]="menu" mat-cell *matCellDef="let element">
                          <span class="material-icons">more_horiz</span>
                          <mat-menu class="course_menu" #menu="matMenu">
                            <button (click)="openConfirmationPopup(element)" mat-menu-item roleAccessControl [accessType]="(element?.status?.toLowerCase()!=='ARCHIVED') ? 'archive':'unarchive'" [ngClass]="{'disable_unarchive_button': (this.clearingPage && element.courseStatus?.toLowerCase() !== 'live') || (!this.clearingPage && courseStatus()?.toLowerCase() !== 'live')}">
                              <span [ngClass]="{'disable_unarchive_menu': (this.clearingPage && element.courseStatus?.toLowerCase() !== 'live') || (!this.clearingPage && courseStatus()?.toLowerCase() !== 'live')}"> {{ element.status != 'ARCHIVED' ? 'Archive' : 'Unarchive' }} </span>
                            </button>
                            <button mat-menu-item (click)="onAddNewNote(element.courseInstanceId)" roleAccessControl accessType="addNotes">
                              <span>Add notes</span>
                            </button>
                            <button (click)="viewNotes(element)" mat-menu-item roleAccessControl accessType="viewNotes">
                              <span>View notes</span>
                            </button>
                            @if (courseTypeId === courseTypeDetails.GeneralCourseTypeId && !clearingPage) {
                              <button mat-menu-item roleAccessControl accessType="manageRelatedCourse" (click)="openRelatedCoursePopup(element)">
                                <span>Add related courses</span>
                              </button>
                            }
                          </mat-menu>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                      [class.active]="row.instanceNew"></tr>
                    </table>
                    <!-- table -->

                    <!-- no-data-found -->
                    @if (filtersApplied() && !totalCourseInstanceCount$()) {
                      <div class="no_data_section">
                        <div class="no_data_alignment">
                          <div class="no_data_avail">No records available</div>
                          <div class="no_data_descript">There are no records to display for the selected filter(s)</div>
                          <img src="../../../../assets/images/top-icon/no-data-found.svg" alt="">
                        </div>
                      </div>
                    }
                    <!-- no-data-found -->
                  </div>
                }

                @if(clearingPage) {
                  @if (totalCourseInstanceCount$()) {
                    <app-page-navigation pageName="manage-campus" [totalCount]='totalCourseInstanceCount$()' [recordsPerPageOption]="[10, 25]"
                      [currentPage]='pageNumber$()' (selectedPage)='getPaginationDetails($event)' />
                  }
                }
                @else {
                @if (totalCourseInstanceCount$()) {
                  <app-page-navigation pageName="manage-campus" [totalCount]='totalCourseInstanceCount$()'
                    [currentPage]='pageNumber$()' (selectedPage)='getPaginationDetails($event)' />
                }
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div roleAccessControl accessType="manageRelatedCourse" popUpContent="pathway-course"></div>
